import { Providers } from '@flightscope/baseball-stats';

const calculatePitchersStats = results => Providers.GameSummaryStatsProvider.calculatePitchersStats(results);

const calculateBattersStats = results => Providers.GameSummaryStatsProvider.calculateBattersStats(results);

export {
  calculatePitchersStats, calculateBattersStats,
};
